//MQDC
import useDecodeToken from "@/utils/hooks/useDecodeJwt";
import dataManagement from "@/navigation/data-management";
import inventory from "@/navigation/inventory";
import privileges from "@/navigation/privileges";
import report from "@/navigation/report";
import banner from "@/navigation/banner";
import tags from "@/navigation/tags";
import fulfillment from "@/navigation/fulfillment";
import document from "@/navigation/document";
import article from "@/navigation/article";
import survey from "@/navigation/survey";

//MQDC Custom mudule
import mqdcReports from "@/constants/navigation/BKIMIKYVPFZC/menu/mqdc-reports";
import dashboard from "@/constants/navigation/BKIMIKYVPFZC/menu/dashboard";
import activity from "@/constants/navigation/BKIMIKYVPFZC/menu/activity";

const { decodeToken } = useDecodeToken();
const renderNavByPermission = () => {
  switch (decodeToken()?.provider_ref) {
    case "PVTR1BT3c2KVas": // Dev MQDC BO EP
    case "PVqK5VJIQ5QAvd": // Prod MQDC BO EP
      switch (decodeToken()?.sub) {
        case "ID_esDV4NDzJaC9": //dev nuttaporn_go@dtgo.com
        case "ID_0p1e1yIpLNQx": //prod nuttaporn_go@dtgo.com
          return [...article];
        case "ID_L74sc6deCc4W": //dev sumalee_la@dtgo.com
        case "ID_YYHCiIBAv8hN ": //prod sumalee_la@dtgo.com
          return [...article, ...mqdcReports];
        case "ID_yztEEahMvcxd": //dev Nutnaree_ap@dtgo.com
        case "ID_F008xqo8dGxF": //prod Nutnaree_ap@dtgo.com
        case "ID_lnqIcF1VzgGt": //dev wanwisa_ya@dtgo.com
        case "ID_DJznyz5qbw4a": //prod wanwisa_ya@dtgo.com
        case "ID_uE27TrXhjzN4": //dev wuttichai_do@dtgo.com
        case "ID_zUMOYi16s9Sz": //prod wuttichai_do@dtgo.com
          return [...article, ...activity];
      }
    default:
      return [
        //dev
        // ...inventory,
        // ...privileges,
        // ...banner,
        // ...article,
        // ...fulfillment,
        // ...document,
        // ...tags,
        // ...dataManagement,
        // ...mqdcReports,
        // ...dashboard,
        // ...activity,
        // ...survey,

        // prod,
        ...dashboard,
        ...dataManagement,
        ...banner,
        ...article,
        ...privileges,
        ...fulfillment,
        ...inventory,
        ...tags,
        ...document,
        ...mqdcReports,
        ...activity,
        ...survey,
      ];
  }
};

export default renderNavByPermission();
